// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";

const clickable: Styleguide["clickable"] = {
    defaultProps: {
        css: focusStyles(),
    },
};

export default clickable;
